import { Pipe, PipeTransform } from '@angular/core';
import { durationToString } from '@mri/functions';

@Pipe({
  name: 'renderDuration',
  standalone: true
})
export class RenderDurationPipe implements PipeTransform {

  transform(value: number, full = false): unknown {
    return durationToString(value, full);
  }

}
